import dotenv from 'dotenv';
import React from 'react';
import { render } from 'react-dom';
import 'abortcontroller-polyfill';
import App from './containers/App/App';
import './shared/style/recaptcha.css';

dotenv.config();

render(
  <App />,
  document.getElementById('root'),
);
